import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import themeColors from '../../assets/styles/themeColors';
import { variables } from '../../assets/styles/variables';
import { pxToRem } from '../../assets/styles/helper';
import { ReactComponent as RadioOn } from '../../assets/images/svg/radio-on.svg';
import { ReactComponent as RadioOff } from '../../assets/images/svg/radio-off.svg';
import { ReactComponent as CheckIcon } from '../../assets/images/svg/check-icon.svg';
import { ReactComponent as CrossIcon } from '../../assets/images/svg/cross-icon.svg';
import { InfoTooltip } from '../Tooltip/InfoTooltip';

const StorageCardElement = styled.div`
  position: relative;
  border: 1px solid
    ${(props) =>
      props.variant === 'premium'
        ? themeColors.colorBrandLight
        : themeColors.colorPrimaryLight};
  border-radius: ${variables.borderRadius.borderRadius};
  background: ${themeColors.colorWhite};
  padding: ${pxToRem(10)} ${pxToRem(10)} 0;
  cursor: pointer;
  flex: 1;

  > svg {
    width: ${pxToRem(16)};
    height: ${pxToRem(16)};
  }
`;

const StorageCardTitle = styled.h2`
  font-family: ${variables.family.goldSilver};
  font-weight: 600;
  color: ${themeColors.colorTextPrimary};
  font-size: ${pxToRem(16)};
  text-align: center;
  margin-bottom: ${pxToRem(6)};
`;

const StorageCardRibbon = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  background-color: ${(props) =>
    props.variant === 'premium'
      ? themeColors.colorBrandLight
      : themeColors.colorTextSecondary};
  color: ${(props) =>
    props.variant === 'premium'
      ? themeColors.colorTextPrimary
      : themeColors.colorWhite};
  display: inline-flex;
  padding: 2px 6px;
  justify-content: center;
  align-items: center;
  font-size: ${pxToRem(14)};
  font-weight: 500;
  border-radius: 0 3px 0 2px;
`;

const StorageCardPriceTag = styled.span`
  display: block;
  font-size: ${pxToRem(10)};
  font-weight: 400;
  color: ${themeColors.colorTextSecondary};
  margin-bottom: 2px;
  text-align: center;
`;

const StoraCardPrice = styled.p`
  font-size: ${pxToRem(14)};
  font-weight: 600;
  margin-bottom: ${pxToRem(16)};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    margin: 4px;
    color: ${(props) =>
      props.variant === 'premium'
        ? themeColors.colorTextOrange
        : themeColors.colorTextSecondary};
  }
`;

const StorageCardInfoIcon = styled.div`
  position: relative;
  padding: ${pxToRem(2)};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StorageCardList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    display: flex;
    align-items: center;
    font-size: ${pxToRem(14)};
    margin-bottom: ${pxToRem(24)};
    color: ${themeColors.colorTextSecondary};

    svg {
      margin: ${pxToRem(5)};
    }
  }
`;

const StorageCard = ({ cardType, selected, onSelect, variant }) => {
  const { t } = useTranslation();
  return (
    <StorageCardElement
      selected={selected}
      onClick={() => onSelect(cardType.id)}
      variant={variant}
    >
      <StorageCardRibbon variant={variant}>{cardType.ribbon}</StorageCardRibbon>
      {selected ? <RadioOn /> : <RadioOff />}
      <StorageCardTitle>{cardType.name}</StorageCardTitle>

      <StorageCardPriceTag>{t('buyWizard.asLowAs')}</StorageCardPriceTag>
      <StoraCardPrice variant={variant}>
        <span>{cardType.price}</span>
        <StorageCardInfoIcon>
          {/* <InfoIcon /> */}
          <InfoTooltip content={cardType.info} />
        </StorageCardInfoIcon>
      </StoraCardPrice>
      <StorageCardList>
        {cardType.features.map((feature, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={index} included={feature.included}>
            {feature.included ? <CheckIcon /> : <CrossIcon />}
            {feature.label}
          </li>
        ))}
      </StorageCardList>
    </StorageCardElement>
  );
};

StorageCard.propTypes = {
  cardType: PropTypes.shape({
    features: PropTypes.arrayOf(PropTypes.shape({})),
    info: PropTypes.string,
    price: PropTypes.string,
    name: PropTypes.string,
    ribbon: PropTypes.string,
    id: PropTypes.string,
  }),
  selected: PropTypes.bool,
  onSelect: PropTypes.func,
  variant: PropTypes.string,
};

export default StorageCard;
